export default __webpack_public_path__ + "static/media/right_arrow.62ae5df0.png";